/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: userProfileApi.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    API calls for User Profile module.

 🔁 Last Updated: 2025-01-XX by Rodrigo Cuadra
────────────────────────────────────────────────────────────────*/

import type { UpdateUserProfilePayload } from '../types';

/**
 * Update user profile
 */
export async function updateUserProfile(
  userId: string | number,
  payload: UpdateUserProfilePayload
): Promise<void> {
  const { default: api } = await import('../../../lib/api');
  
  await api.put(`/api/users/${userId}`, payload);
}

